<template>
<section class="fancy">
	<div class="container">
		<div class="fancy-box">
			<div class="headline-lg">Software</div>
			<p>You can download and install the application for your prefered operating system once it is available for you.</p>
			<div class="box-wrapper">
				<div class="box box-lg">
					<div class="box-inner">
						<div class="image"><img src="~@/assets/img/img_app_preview_win.png" alt="Image App Windows"></div>
						<div class="title">Alpha <span v-html="this.version"></span></div>
						<!-- <div class="title">Alpha <span>v0.5.1</span></div> -->
						<div class="info">For Windows</div>
						<div v-if="!hasDownload('windows')" class="button-wrapper"><a class="button disabled">coming soon</a></div>
						<div v-else class="button-wrapper">
							<a href="https://deios-api.prd.dungeonfog.com/download?p=windows" class="button">Download Now</a>
							<!-- <a href="https://dungeonfog.ams3.digitaloceanspaces.com/deios.msix" class="button">Download Now</a> -->
						</div>
					</div>
				</div>
				<div class="box box-lg">
					<div class="box-inner">
						<div class="image"><img src="~@/assets/img/img_app_preview_mac.png" alt="Image App Mac"></div>
						<div class="title">Alpha <span v-html="this.version"></span></div>
						<!-- <div class="title">Alpha <span>v0.5.1</span></div> -->
						<div class="info">For macOS</div>
						<!-- <div class="info">For macOS
							<select @change="onChange($event)" v-model="processor" class="mac_processor_type" id="mac_processor_type">
								<option value="mac-intel" selected>Intel</option>
								<option value="mac-arm">ARM</option>
							</select>
						</div> -->
						<div v-if="!hasDownload('macos')" class="button-wrapper"><a class="button disabled">coming soon</a></div>
						<div v-else class="button-wrapper">
							<a href="https://deios-api.prd.dungeonfog.com/download?p=mac-intel" class="button">Download Now</a>
							<!-- <a :href="'https://deios-api.prd.dungeonfog.com/download?p=' + this.processor" class="button">Download Now</a> -->
							<!-- <a href="https://dungeonfog.ams3.digitaloceanspaces.com/Deios.dmg" class="button">Download Now</a> -->
						</div>
					</div>
				</div>
				<div class="box box-lg">
					<div class="box-inner">
						<div class="image"><img src="~@/assets/img/img_app_preview_linux.png" alt="Image App Linux"></div>
						<div class="title">Alpha <span v-html="this.version"></span></div>
						<!-- <div class="title">Alpha <span>v0.5.1</span></div> -->
						<div class="info">For Linux</div>
						<div v-if="!hasDownload('linux')" class="button-wrapper"><a class="button disabled">coming soon</a></div>
						<div v-else class="button-wrapper">
							<a href="https://deios-api.prd.dungeonfog.com/download?p=linux" class="button">Download Now</a>
							<!-- <a href="https://dungeonfog.ams3.digitaloceanspaces.com/deios-linux-v0.5.1.zip" class="button">Download Now</a> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
</template>

<script>
export default {
	name: 'SectionFancySoftware',
	props: {
		user: Object,
		phase: Object,
	},
	data: () => ({
        version: '...',
		processor: 'mac-intel'
    }),
	created() {
		fetch('//deios-api.prd.dungeonfog.com/version')
		.then(response => {
			if (!response.ok) {
				throw Error(response.statusText);
			}
			return response.text();
		})
		.then(data => { this.version = data; })
		.catch(() => { this.version = 'v0.5.0'; }) // old: v0.1.1
	},
	methods: {
		onChange(event) {
            this.processor = event.target.value;
			// console.log(event.target.value);
        },
		hasDownload: function(os) {
			if (
				this.user.token.groups.includes('/Bronze') ||
				this.user.token.groups.includes('/Silver') ||
				this.user.token.groups.includes('/Gold') ||
				this.user.token.groups.includes('/Gold PLUS') ||
				this.user.token.groups.includes('/Lifetime 2017')
			) {
				return this.phase.access.some(r => this.user.token.dev_access.includes(r)) &&
				this.phase.download.includes(os);
			}

			if(
				typeof this.user.token.dungeonfog !== 'undefined' &&
				typeof this.user.token.dev_access !== 'undefined'
			) {
				return this.user.token.dungeonfog.standalone_keys > 0 &&
				this.phase.access.some(r => this.user.token.dev_access.includes(r)) &&
				this.phase.download.includes(os);
			}
			return false
		},
		// download: event => {
		// 	let elm = document.createElement("a");
		// 	elm.href = event.target.href;
		// 	elm.click();
		// },
	},
}
</script>
